import defaultTheme from '@cld/themes';
import { globalThemeId } from '../utils/globalThemeId';
import { createTheme } from './createTheme';

export const globalTheme = createTheme(defaultTheme, globalThemeId);

export type GlobalTheme = ReturnType<typeof globalTheme>;
